import { render, staticRenderFns } from "./DsTabs.vue?vue&type=template&id=29e628f1&scoped=true&"
import script from "./DsTabs.vue?vue&type=script&lang=js&"
export * from "./DsTabs.vue?vue&type=script&lang=js&"
import style0 from "./DsTabs.vue?vue&type=style&index=0&id=29e628f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e628f1",
  null
  
)

export default component.exports